// src/components/Affiliates.jsx
import React, { useState, useEffect } from 'react';
import '../App.css';
import { useNavigate } from 'react-router-dom';
import { Button } from 'reactstrap';
import MyStorage from './util/storage';
import { Oval as Loader } from 'react-loader-spinner';
import Api from './api/api'; 
import { ToastContainer } from 'react-toastify';
import showToast from './util/toast';

const Affiliates = () => {
  const navigate = useNavigate();
  const [affiliates, setAffiliates] = useState([]);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    // redirect if not logged in
    if (!MyStorage.isLogin()) {
      navigate('/admin/login', { replace: true });
      return;
    }
    // load affiliates if logged in
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    Api.getAffiliates(
      (response) => {
        setLoader(false);
        setAffiliates(response);
      },
      () => {
        setLoader(false);
        showToast('error', 'Failed to load affiliates!');
      }
    );
  };

  const editAffiliate = (item) => {
    navigate('/admin/add-affiliate', { state: { model: item } });
  };

  const deleteAffiliate = (item) => {
    if (!window.confirm('Are you sure you want to delete this affiliate product?')) return;

    const temp = affiliates.filter(p => p.id !== item.id);
    setAffiliates(temp);

    Api.deleteAffiliate(item, ()=>{
      //
    })
  };

  return (
    <div className='main'>
      <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
        <div style={{ color: 'blue' }}>Affiliates</div>
      </div>

      <div style={{ width: '100%', display: 'flex', flexDirection: 'column', padding: 0 }}>
        <div style={{ padding: 30, display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'scroll' }}>
          <Button
            className='btn-block btn-dark'
            style={{ marginTop: 10, fontSize: 18, fontWeight: 'bold', backgroundColor: 'green', borderWidth: 0, height: 40, width: 300, alignSelf: 'center' }}
            onClick={() => navigate('/admin/add-affiliate', { state: { model: null } })}>
            Add Affiliate Product
          </Button>

          <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'center' }}>
            {affiliates.map((item, index) => (
              <div key={index} style={{ width: '100%', backgroundColor: 'white', marginTop: 10, padding: 0, marginRight: 10, display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                <div style={{ display: 'flex', backgroundColor: '#f2f2f2', padding: 10 }}>
                  <div>
                    {item.images && item.images.length > 0 ? (
                      <img src={item.images[0]} alt='' style={{ width: 120, height: 120, objectFit: 'cover', marginRight: 15 }} />
                    ) : (
                      <div style={{ width: 120, height: 120, backgroundColor: '#fff', marginRight: 15, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'gray' }}>No Image</div>
                    )}
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'center' }}>
                    <div style={{ fontSize: 16 }}>{item.title}</div>
                    <div style={{ fontSize: 14, color: 'gray', marginTop: 5 }}>Price: ${item.price}</div>

                    <div style={{ display: 'flex', marginTop: 10 }}>
                      <Button
                        style={{ fontSize: 16, fontWeight: 'bold', backgroundColor: 'orange', borderWidth: 0, height: 40, width: 100, marginRight: 10 }}
                        onClick={() => editAffiliate(item)}>
                        Edit
                      </Button>
                      <Button
                        style={{ fontSize: 16, fontWeight: 'bold', backgroundColor: 'red', borderWidth: 0, height: 40, width: 100 }}
                        onClick={() => deleteAffiliate(item)}>
                        Delete
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {loader && (
        <div style={{ position: 'absolute', display: 'flex', flex: 1, alignItems: 'center', justifyContent: 'center', height: '80%', width: '80%' }}>
          <Loader type="ThreeDots" color="white" height={70} width={70} visible={true} />
        </div>
      )}

      <ToastContainer />
    </div>
  );
};

export default Affiliates;
